import * as React from "react";
import Report6PreviewRiskCriteriasGrid from "./Report6PreviewRiskCriteriasGrid";
import { TReport6ReportingPeriodPresentationModel } from "../../../presenter/report/model/Report6ReportingPeriodPresentationModel";
import { TReport6ReportPresentationModel } from "../../../presenter/report/model/Report6ReportPresentationModel";
import DataGrid from "../app/grid/DataGrid";
import TickBox from "../app/grid/TickBox";

const Report6PreviewReportsGrid = ({
  translate,
  reportingPeriod
}: {
  translate: any;
  reportingPeriod: TReport6ReportingPeriodPresentationModel;
}) => {
  const reports = reportingPeriod.reports?.map(
    (report: TReport6ReportPresentationModel) => {
      return { ...report, key: report.id };
    }
  );

  const columns = [
    {
      key: "reportTypeName",
      dataIndex: "reportTypeName",
      title: translate("report6_preview_reports_grid.report_type_name")
    },
    {
      key: "version",
      dataIndex: "version",
      title: translate("report6_preview_reports_grid.version"),
      align: "right"
    },
    {
      key: "submitDate",
      dataIndex: "submitDate",
      title: translate("report6_preview_reports_grid.submit_date"),
      sorter: (a, b) =>
        DataGrid.SortHelper.compareDateString(a.submitDate, b.submitDate)
    },
    {
      key: "submitReason",
      dataIndex: "submitReason",
      title: translate("report6_preview_reports_grid.submit_reason")
    },
    {
      key: "regularEvaluationStatus",
      dataIndex: "regularEvaluationStatus",
      title: translate("report6_preview_reports_grid.regular_evaluation_status")
    },
    {
      key: "regularEvaluationDate",
      dataIndex: "regularEvaluationDate",
      title: translate("report6_preview_reports_grid.regular_evaluation_date"),
      sorter: (a, b) =>
        DataGrid.SortHelper.compareDateString(
          a.regularEvaluationDate,
          b.regularEvaluationDate
        )
    },
    {
      key: "formalEvaluationStatus",
      dataIndex: "formalEvaluationStatus",
      title: translate("report6_preview_reports_grid.formal_evaluation_status")
    },
    {
      key: "formalEvaluationDate",
      dataIndex: "formalEvaluationDate",
      title: translate("report6_preview_reports_grid.formal_evaluation_date"),
      sorter: (a, b) =>
        DataGrid.SortHelper.compareDateString(
          a.formalEvaluationDate,
          b.formalEvaluationDate
        )
    },

    {
      key: "riskCriterias",
      title: translate("report6_preview_reports_grid.satisfied_risk_criterias"),
      render: (text: string, record: TReport6ReportPresentationModel) => (
        <Report6PreviewRiskCriteriasGrid
          report={record}
          translate={translate}
        />
      )
    },
    {
      key: "financialImbalance",
      title: translate("report6_preview_reports_grid.financial_imbalance"),
      render: (text, record) => (
        <div style={{ textAlign: "center" }}>
          <TickBox value={record.financialImbalance} />
        </div>
      ),
      fixed: "right"
    }
  ];

  return (
    <div style={{ marginBottom: "1em" }}>
      <DataGrid
        translate={translate}
        key={`reports-table-${reportingPeriod.reportingPeriodId}`}
        columns={columns}
        dataSource={reports}
        booleanColumnKeys={["financialImbalance"]}
      ></DataGrid>
    </div>
  );
};

export default Report6PreviewReportsGrid;
